import Backdrop from "@mui/material/Backdrop";
import {
  Button,
  Col,
  Popconfirm,
  Row,
  Table,
  TableProps,
  Tooltip,
  Typography,
} from "antd";
import AdminLayout from "../../../component/AdminLayout";
import SearchBar from "../../../component/Search";
import CircularProgress from "@mui/material/CircularProgress";
import { useEffect, useState } from "react";
import ManageIp from "../components/ManageIp";
import {
  DeleteServer,
  GetLicenseColumns,
  GetServerLicense,
  axiosErrorMessages,
} from "../../../API/api";
import { enqueueSnackbar } from "notistack";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { customSortDirections } from "../../../Utils/utils";
import AddServer from "../components/AddServer";
import EditServerLicense from "../components/EditServerLicense";
import { useAppRole, useUserRole } from "../../../API/RoleContext";
import { SorterResult } from "antd/es/table/interface";
import axios, { AxiosError } from "axios";

const ServerLicense = () => {
  const userRole = useUserRole();
  const appRole = useAppRole();
  const [sortedInfo, setSortedInfo] = useState<SorterResult<any>>({});

  const [currentPage, setCurrentPage] = useState<number>(1);
  const [transformedData, setTransformedData] = useState([]);
  const [selectedColumnList, setSelectedColumnList] = useState<any>([]);
  const [newColumn, setNewColumns] = useState<any>([]);
  const [isOpenEditServerLicense, setIsOpenServerLicense] =
    useState<boolean>(false);
  const [editDetails, setEditDetails] = useState([]);
  const [pagesize, setPageSize] = useState<number>(50);

  const [isAddNewServerLicense, setIsAddNewServerLicense] =
    useState<boolean>(false);
  const columns = [
    {
      title: "No",
      dataIndex: "id",
      key: "id",
      fixed: "left",
      width: "10%",

      render: (text: any, record: any, index: number) =>
        (currentPage - 1) * pagesize + index + 1,
    },
    {
      title: "Server",
      dataIndex: "serverName",
      fixed: "left",
      width: "30%",

      key: "serverName",
      render: (text: string) => (
        <Tooltip placement="topLeft" title={text}>
          <div className="truncate-text">{text}</div>
        </Tooltip>
      ),
    },
    {
      title: "IP Address",
      dataIndex: "ipAddress",
      key: "ipAddress",
      width: "20%",

      render: (text: string, record: any) => (
        <Tooltip placement="topLeft" title={text}>
          <div className="truncate-text">{text}</div>
        </Tooltip>
      ),
    },
    {
      title: "Asset ID",
      dataIndex: "assetTagId",
      key: "assetTagId",
      width: "20%",

      render: (text: string, record: any) => (
        <Tooltip placement="topLeft" title={text}>
          <div className="truncate-text">{text}</div>
        </Tooltip>
      ),
    },
    {
      title: "Other",
      dataIndex: "otherCount",
      key: "otherCount",
      width: "20%",
      render: (text: string, record: any) => (
        <Tooltip placement="topLeft" title={record.other}>
          <div className="truncate-text">{text}</div>
        </Tooltip>
      ),
    },
    {
      title: "OS",
      dataIndex: "OS",
      key: "OS",
      width: "20%",
      render: (text: string, record: any) => (
        <Tooltip placement="topLeft" title={text}>
          <div>{text}</div>
        </Tooltip>
      ),
    },

    ...(!userRole.includes("Manager") && !userRole.includes("CEO")
      ? [
          {
            title: "Action",
            dataIndex: "action",
            width: "10%",

            render: (_: any, record: any) => {
              return (
                <>
                  {" "}
                  <Typography.Link onClick={() => handleEdit(record)}>
                    <EditOutlined />
                  </Typography.Link>
                  {appRole === "Admin" && (
                    <Popconfirm
                      title="Do you want to delete the server?"
                      onConfirm={() => handleDelete(record)}
                    >
                      <Typography.Link className="delete-btn">
                        <DeleteOutlined />
                      </Typography.Link>
                    </Popconfirm>
                  )}
                </>
              );
            },
          },
        ]
      : []),
  ];
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [openManageIp, setOpenManageIp] = useState<boolean>(false);
  const [serverList, setServerList] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    getServerList();
    getSelectedColumns();
  }, []);

  useEffect(() => {
    if (serverList.length > 0) {
      const transformedArrayNew: any = serverList.map((item: any) => {
        const softwareVersions: { [key: string]: string } = {};
        item.licenseSoftwares.forEach((software: any) => {
          if (software)
            softwareVersions[software.softwareName] = software.softwareVersions
              .map(
                (version: { versionId: number; versions: string }) =>
                  version.versions
              )
              .join(", ");
        });

        return {
          serverAssetId: item.assetId,
          serverName: item.serverName,
          ipAddress: item.ipAddress,
          assetTagId: item.assetTagId,
          licenseSoftwares: item.licenseSoftwares,
          otherSoftwares: item.othersSoftwares,
          otherCount: item.othersSoftwares.length,

          other: item.othersSoftwares
            .map((version: any) => version.softwareName)
            .join(", "),
          ...softwareVersions,
        };
      });
      setTransformedData(transformedArrayNew);
    }
  }, [serverList]);

  useEffect(() => {
    // if (selectedColumnList.length > 0) {
    const newColumn = [...columns, ...selectedColumnList];
    //changing order
    const actionIndex = newColumn.findIndex(
      (item: any) => item.title === "Action"
    );

    // If 'Action' is found, remove it from the array and push it to the end
    if (actionIndex !== -1) {
      const actionItem = newColumn.splice(actionIndex, 1)[0];
      newColumn.push(actionItem);
    }

    setNewColumns(newColumn);
    // }
  }, [selectedColumnList]);

  const getSelectedColumns = async () => {
    try {
      setIsLoading(true);
      const response = await GetLicenseColumns();
      const transformedArray = response.data
        .sort((a: any, b: any) => a.columnId - b.columnId)
        .filter((item: any) => item.columnOrder != 0) // Filter items with columnOrder 0
        .map((item: any, index: number) => ({
          title: item.softwareName, // Convert to lowercase for consistency
          order: index,
          width: "20%",
          dataIndex: item.softwareName, // Convert to lowercase for consistency
          render: (text: string, record: any) => (
            <Tooltip placement="topLeft" title={text}>
              <div className="truncate-text">{text}</div>
            </Tooltip>
          ),
        }));

      setSelectedColumnList(transformedArray);
      setIsLoading(false);
    } catch (error: any) {
      let errorMsg;
      if (axios.isAxiosError(error)) {
        const axiosError = error as AxiosError;
        errorMsg = axiosErrorMessages(axiosError);
      } else {
        errorMsg = error.message;
      }
      enqueueSnackbar(errorMsg, {
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });
      // enqueueSnackbar("Error in fetching data", {
      //   variant: "error",
      //   anchorOrigin: {
      //     vertical: "top",
      //     horizontal: "right",
      //   },
      // });
      setIsLoading(false);
    }
  };

  const handleEdit = (rowData: any) => {
    setEditDetails(rowData);
    setIsOpenServerLicense(true);
  };
  const handleDelete = (rowData: any) => {
    setIsLoading(true);
    DeleteServer(rowData.serverAssetId)
      .then((response: any) => {
        enqueueSnackbar("Deleted Successfully", {
          variant: "success",
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        });

        setIsLoading(false);
        getServerList();
      })
      .catch((error: any) => {
        enqueueSnackbar("Error in Deleting", {
          variant: "error",
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        });
        setIsLoading(false);
      });
  };
  const getServerList = async () => {
    try {
      setIsLoading(true);
      const response = await GetServerLicense();
      const newData = response.data.map((ip: any, index: number) => ({
        ...ip,
        key: ip.ipAddressId,
      }));
      setServerList(newData);
      setIsLoading(false);
    } catch (error: any) {
      enqueueSnackbar(error, {
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });
      setIsLoading(false);
    }
  };

  const handleSearch = (value: any) => {
    setCurrentPage(1);
    setSearchText(value);
    filterData(value);
  };
  const filterData = (searchText: string) => {
    if (!searchText) {
      setFilteredData([]);
    } else {
      const filtered = transformedData.filter((item: any) =>
        item.serverName.toLowerCase().includes(searchText.toLowerCase())
      );
      setFilteredData(filtered);
    }
  };
  const handleAddNewServerLicense = () => {
    setIsAddNewServerLicense(true);
  };
  const handleManageIP = () => {
    setOpenManageIp(true);
  };
  const handleClosePopup = () => {
    setOpenManageIp(false);
  };
  const handleChange: TableProps<any>["onChange"] = (
    pagination,
    filters,
    sorter
  ) => {
    setSortedInfo(sorter as SorterResult<any>);
    setCurrentPage(pagination.current || 1);
    setPageSize(pagination.pageSize ?? 50);
  };
  return (
    <>
      {" "}
      <AdminLayout>
        <Backdrop
          sx={{
            color: "#fff",
            zIndex: (theme: any) => theme.zIndex.drawer + 1,
          }}
          open={isLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <div>
          <div className="employee-table-header ">
            <Row
              gutter={16}
              style={{ alignItems: "center", margin: "12px 16px" }}
            >
              <Col className="gutter-row" lg={12} sm={24}>
                <h3 className="bottom-margin-mob" style={{ float: "left" }}>
                  Server License
                </h3>
              </Col>
              <Col
                className="gutter-row pm-search-flex"
                lg={{ span: 10, offset: 2 }}
                sm={24}
                xs={24}
                style={{ display: "flex" }}
              >
                <SearchBar
                  width={"100%"}
                  onSearch={handleSearch}
                  placeholder={"Search Server"}
                />
                {!userRole.includes("Manager") && !userRole.includes("CEO") && (
                  <>
                    <Button
                      onClick={handleAddNewServerLicense}
                      type="primary"
                      style={{ marginLeft: 10 }}
                      size="small"
                    >
                      Add New
                    </Button>
                    <Button
                      onClick={handleManageIP}
                      type="primary"
                      style={{ marginLeft: 10 }}
                      size="small"
                    >
                      Manage IP
                    </Button>
                  </>
                )}
              </Col>
            </Row>
          </div>

          <Table
            sortDirections={customSortDirections}
            className="status-list-admin"
            columns={newColumn}
            onChange={handleChange}
            tableLayout="fixed"
            scroll={{ x: 1500, y: 400 }}
            size="small"
            pagination={{
              current: currentPage,
              showSizeChanger: true,
              defaultPageSize: 50,
            }}
            rowClassName="editable-row"
            dataSource={searchText ? filteredData : transformedData}
          />
        </div>
        {isAddNewServerLicense && (
          <AddServer
            closeAddPopup={() => {
              getServerList();
              setIsAddNewServerLicense(false);
            }}
          />
        )}
        {openManageIp && <ManageIp handleClose={handleClosePopup} />}
        {isOpenEditServerLicense && (
          <EditServerLicense
            closeAddPopup={() => {
              getServerList();
              setIsOpenServerLicense(false);
            }}
            editDetails={editDetails}
          />
        )}
      </AdminLayout>
    </>
  );
};

export default ServerLicense;
